import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useReportFilterBarStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    ...shorthands.gap(tokens.spacingHorizontalM),
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  dropdown: {
    minWidth: '200px',
  },
});
